<template>
    <div class="add-edit-purchase-order">
        <v-form @submit.prevent="submitPurchaseOrderDetails" v-model="purchaseOrderDetailsForm" ref="purchaseOrderDetailsForm">
            <v-row>
                <v-col cols="8">
                    <h1 class="text-left ml-8 my-2">
                        <span v-if="!is_editing">Add</span>
                        <span v-else>Edit</span> Purchase Order
                    </h1>
                    <p v-if="!is_editing" class="text-left ml-8">Add a new Purchase Order.</p>
                    <p v-else class="text-left ml-8">Edit Purchase Order Details.</p>
                    <h5 class="text-left ml-8 font-weight-regular">* indicates required field</h5>

                </v-col>
                <v-col cols="4" class="text-right">
                    <v-btn
                        v-if="is_editing && currentUser.privileges.canDeletePurchaseOrders"
                        color="red"
                        class="my-2 mr-8"
                        dense
                        small
                        @click="showDeleteDialog"
                        rounded
                        outlined
                    >Delete</v-btn>
                </v-col>
            </v-row>
            <v-row class="mx-4">
                <v-col cols="12">
                    <v-card>
                        <v-container>
                            <v-row>
                                <!-- <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Order Number
                                        <span class="required"></span>
                                    </p>
                                    <v-text-field
                                        v-model="purchase_order.order_number"
                                        outlined
                                        :rules="[rules.required, rules.order_number]"
                                        dense
                                        placeholder="eg. RQ-101D"
                                        class="rounded-input"
                                        hide-details="auto"
                                        maxlength="9"
                                    ></v-text-field>
                                </v-col> -->
                                 <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Store Item
                                    <span class="required"></span>
                                    </p>
                                    <v-autocomplete
                                        v-model="purchase_order.store_item"
                                        :items="$route.params.item_id ? purchase_order.store_item : store_items"
                                        item-text="item_name"
                                        item-value="id"
                                        class="rounded-input"
                                        :rules="[rules.required]"
                                        outlined
                                        :disabled="$route.params.item_id"
                                        dense
                                        hide-details="auto"
                                        return-object
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">Reference</p>
                                    <v-text-field
                                        v-model="purchase_order.reference"
                                        outlined
                                        dense
                                        placeholder="eg. Application #313"
                                        class="rounded-input"
                                        maxlength="250"
                                        hide-details="auto"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    User
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                           <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-2"
                                                >
                                                mdi-help-circle
                                            </v-icon>
                                        </template>
                                        <span>User who might have requested for requisition.</span>
                                    </v-tooltip>
                                    </p>
                                    <v-autocomplete
                                        v-model="purchase_order.user"
                                        :items="staff"
                                        item-text="full_name"
                                        item-value="id"
                                        class="rounded-input"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        return-object
                                    >
                                    </v-autocomplete>
                                </v-col>
                               
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Quantity (no of units)
                                    <span class="required"></span>
                                    
                                    </p>
                                    <v-text-field
                                        v-model="purchase_order.quantity"
                                        :rules="[rules.requiredNumbersOnly, rules.nonZero]"
                                        required
                                        outlined
                                        dense
                                        placeholder="eg. 5"
                                        type="number"
                                        class="rounded-input"
                                        hide-details="auto"
                                        min=0
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Unit Price (₹)
                                    <span class="required"></span>

                                    </p>
                                    <v-text-field
                                        v-model="purchase_order.unit_price"
                                        :rules="[rules.requiredNumbersOnly]"
                                        required
                                        outlined
                                        dense
                                        placeholder="eg. 80.5"
                                        type="number"
                                        class="rounded-input"
                                        hide-details="auto"
                                        min=0
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Tax (%)
                                    <span class="required"></span>

                                    </p>
                                    <v-text-field
                                        v-model="purchase_order.tax"
                                        :rules="[rules.requiredNumbersOnly]"
                                        required
                                        outlined
                                        dense
                                        placeholder="eg. 5.0"
                                        type="number"
                                        class="rounded-input"
                                        hide-details="auto"
                                        min=0
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Discount (%)
                                    <span class="required"></span>

                                    </p>
                                    <v-text-field
                                        v-model="purchase_order.discount"
                                        required
                                        outlined
                                        :rules="[rules.requiredNumbersOnly]"
                                        dense
                                        placeholder="eg. 5.0"
                                        type="number"
                                        class="rounded-input"
                                        hide-details="auto"
                                        min=0
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <p class="text-left mx-2 mb-1">
                                    Supplier
                                    <span class="required"></span>
                                    </p>
                                    <v-autocomplete
                                        v-model="purchase_order.supplier"
                                        :items="suppliers"
                                        :rules="[rules.required]"
                                        item-text="supplier_name"
                                        item-value="id"
                                        class="rounded-input"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        return-object
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="4" class="mb-0">
                                <p class="text-left mx-2 mb-1">
                                Expiry Date
                                </p>
                                <v-menu
                                    ref="expiry_date_menu"
                                    v-model="expiry_date_menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="purchase_order.expiry_date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formattedDate(purchase_order.expiry_date)"
                                        append-icon="fas fa-calendar"
                                        readonly
                                        outlined
                                        dense
                                        class="rounded-input"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                    </template>
                                    <v-date-picker :min="new Date().toISOString()" v-model="purchase_order.expiry_date" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="expiry_date_menu = false">Cancel</v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.expiry_date_menu.save(purchase_order.expiry_date)"
                                    >OK</v-btn>
                                    </v-date-picker>
                                </v-menu>
                                </v-col>
                                
                            </v-row>
                            <div class="text-right mx-4 my-4">
                                <v-btn
                                    class="mr-4"
                                    color="red"
                                    :to="{ name:'PurchaseOrderDetails', params: { po_id: this.$route.params.po_id } }"
                                    v-if="is_editing"
                                    rounded
                                    outlined
                                >Cancel</v-btn>
                                <v-btn
                                    class="mr-4"
                                    color="red"
                                    :to="{name:'PurchaseOrders' }"
                                    v-else
                                    rounded
                                    outlined
                                >Cancel</v-btn>
                                <v-btn color="primary" type="submit" :disabled="!purchaseOrderDetailsForm" rounded>Submit</v-btn>
                            </div>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>
        <DeleteConfirmationDialog
            title="Are you sure you want to delete this Purchase Order?"
            :visible="showDeleteConfirmation"
            @deleteObject="deleteObjectConfirmation"
        />
        <v-snackbar v-model="snackbar.visible" timeout="5000" :color="snackbar.color" multi-line>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn dark text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
import moment from 'moment';

export default {
    name: 'AddEditPurchaseOrder',
    components:{
        DeleteConfirmationDialog,
    },
    data(){
        return{
            purchaseOrderDetailsForm: false,
            expiry_date_menu: false,
            is_editing: false,
            moment: moment,
            rules: {
                required: (v) => !!v || "This field is required",
                requiredNumbersOnly: (v) => v===0 || !!v || "This field is required",
                nonZero: (v) => v!=0 || "Cannot be 0",
                order_number: (v) => /^[a-zA-Z0-9-_ ]{1,55}$/.test(v) || "Invalid",
                code: (v) => /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid",
                numbersOnly: (v) => !v || !/[^0-9]/.test(v) || "Invalid",

            },
            purchase_order: {
                id: null,
                order_number: null,
                reference: null,
                user: {
                    id: null,
                    full_name: null,
                },
                store_item: null,
                quantity: 0,
                unit_price: 0,
                discount: 0,
                tax: 0,
                expiry_date: null,
                created: null,
                last_edited: null,
                status: null,
                supplier: null,
                institution: null,
            },
            showDeleteConfirmation: false,
            snackbar: {
                visible: false,
                message: "",
                color: "dark",
            },
            staff: [],
            store_items: [],
            suppliers: [],
        };
    },
    computed:{
        ...mapGetters(["currentUser", "accessToken", "isLoading"]),
        essentials(){
            return{
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        }
    },
    methods:{
        ...mapActions(["setLoading"]),
        async getAllStaff(){
            this.staff = await api.call(this.essentials, endpoints.getAllFaculty);
        },

        async getAllStoreItems(){
            var url = endpoints.storeItem + "?count=-1"
            this.store_items = await api.call(this.essentials, url);
        },

        async getSpecificStoreItem(){
            var url = endpoints.storeItem + this.$route.params.item_id +"/";
            this.purchase_order.store_item = await api.call(this.essentials, url);
        },

        

        async getAllSuppliers(){
            this.suppliers = await api.call(this.essentials, endpoints.suppliers);

        },
        
        async getPurchaseOrderDetails(){
            var url = endpoints.purchaseOrders + this.$route.params.po_id + "/";
            this.purchase_order = await api.call(this.essentials, url);
        },

        
        async submitPurchaseOrderDetails(){
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: endpoints.purchaseOrders,
                responseVar: response,
                method: api.Methods.POST,
                body: {
                    is_editing: this.is_editing,
                    reference: this.purchase_order.reference,
                    edit_id: this.is_editing? this.purchase_order.id : null,
                    store_item_id: this.purchase_order.store_item.id,
                    quantity: this.purchase_order.quantity,
                    unit_price: this.purchase_order.unit_price,
                    tax: this.purchase_order.tax,
                    discount: this.purchase_order.discount,
                    expiry_date: this.purchase_order.expiry_date,
                    user_id : this.purchase_order.user.id,
                    supplier_id: this.purchase_order.supplier.id,
                }
            });
            if(response){
                this.$router.push({ name: 'PurchaseOrderDetails', params: { po_id: response.id } })
            }
        },

        async showDeleteDialog() {
            this.showDeleteConfirmation = true;
        },

        async deleteObjectConfirmation(confirm) {
            this.showDeleteConfirmation = false;
            var url = endpoints.purchaseOrders + this.purchase_order.id + "/";
            if (confirm) {
                var response;
                response = await api.handleApi({
                    apiEssentials: this.essentials,
                    url: url,
                    method: api.Methods.DELETE,
                    responseVar: response,
                });
                if (response) {
                    this.$router.push({ name: "PurchaseOrders", });
                }
            }
        },

        formattedDate(date) {
            if (!date) return "";
            return moment(date).format("D MMM YYYY");
        },


        // handles api errors
        handleApiErrors(err) {
            this.setLoading(false);
            if (err.response) {
                console.log(err.response);
                if (err.response.status == 409) {
                    this.snackbar.message = err.response.data.message;
                    this.snackbar.visible = true;
                } 
            }
            else {
                this.snackbar.message = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },
    },
    created(){
        if(this.$route.params.po_id){
            this.is_editing = true;
            this.getPurchaseOrderDetails();
        }
        this.getAllStaff();
        this.getAllSuppliers();
        if(this.$route.params.item_id){
            this.getSpecificStoreItem();
        }
        else{
            this.getAllStoreItems();
        }
    }

}
</script>

<style scoped>
.text-white {
  color: white !important;
}
.rounded-input {
  border-radius: 12px !important;
}

</style>
